import CurrentLocationPreview from "./../../ViewInterview/AvailabilityAndConditions/CurrentLocationPreview";
import SalaryPreview from "./../../ViewInterview/AvailabilityAndConditions/SalaryPreview";

export default function SalaryPerLocation({ model, index }) {
  
  return (
    <>
      {model?.salaryExpected !== null ? (
        <div>
          <div className="salary-info">
            <CurrentLocationPreview
              currentLocation={model?.currentLocation || {}}
              viewMode={true}
            />
          </div>
          <SalaryPreview model={model} mainLabel={"Salary"} index={index} />
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}
